import { type FC } from 'react';
import BaseDrawer from 'components/atoms/base-drawer';
import { ModuleType } from 'infrastructure/enums';
import { CreateOrUpdateKeyNoteModal } from 'components/organisms/admin-panel-key-notes/modal/create-or-update-key-note';
import KeyNotesContent from 'components/organisms/admin-panel-key-notes/key-notes-content';
import BaseCheckbox from 'components/atoms/baseCheckbox';
import BaseButton from 'components/atoms/baseButton';
import ChevronLeftIcon from 'components/atoms/icons/chevronLeft';
import PlusIcon from 'components/atoms/icons/plus';
import { useTranslation } from 'react-i18next';
import { useCheckRoleAccess } from 'infrastructure/hooks';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';

import { useDrawer } from './hooks/use-drawer';
import s from './styles.module.scss';

interface NotesDrawerProps {}

const NotesDrawer: FC<NotesDrawerProps> = () => {
  const {
    handleCloseDrawer,
    setOpenModal,
    setShowExpired,
    handleSave,
    openModal,
    isOpenDrawer,
    keynotes,
    patientGuid,
    saveNoteLoading,
    tableNote,
    showExpired,
    reloadTable,
    keynotesLoading,
  } = useDrawer();
  const { t } = useTranslation();

  const title = `${tableNote?.patientName ?? ''}`;
  const { isReadOnlyRole } = useCheckRoleAccess();

  return (
    <>
      <BaseDrawer open={isOpenDrawer} onClose={handleCloseDrawer}>
        <div className={s.header}>
          <BaseButton
            icon={<ChevronLeftIcon />}
            type="secondary"
            onClick={handleCloseDrawer}
          />
          <h5>{title}</h5>
        </div>
        <div className={s['keynotes-wrapper']}>
          <div className={s['controller-wrapper']}>
            <BaseCheckbox
              checked={showExpired}
              onChange={setShowExpired}
              className={s.showExpired}
              label={t('labels.showExpiredEntries')}
            />
            <BaseButton
              type="primary"
              label={t('controls.add')}
              onClick={() => {
                setOpenModal(true);
              }}
              loading={saveNoteLoading}
              disabled={isReadOnlyRole}
              icon={<PlusIcon />}
            />
          </div>
          <div className={s.spaccer}>
            <hr />
          </div>
          <BaseSpinWrapper spinning={keynotesLoading}>
            <div className={s['keynotes-wrapper']}>
              <KeyNotesContent
                module={ModuleType.CCM}
                showExpired={showExpired}
                isDataEmpty={!keynotes?.length}
                data={keynotes}
                patientGuid={patientGuid}
                onAction={reloadTable}
              />
            </div>
          </BaseSpinWrapper>
        </div>
      </BaseDrawer>
      <CreateOrUpdateKeyNoteModal
        onCancel={() => setOpenModal(false)}
        moduleType={ModuleType.CCM}
        isOpen={openModal}
        isLoading={saveNoteLoading}
        onSave={(values) => {
          handleSave(values);
        }}
      />
    </>
  );
};
export default NotesDrawer;
